import ApiService from './ApiService';

/**
 * Service for handling synchronization operations.
 */
class SyncService extends ApiService {

    /**
     * Checks the synchronization status.
     * @returns {Promise} A promise that resolves with the response data.
     * @throws {Error} If the request fails.
     */
    async checkSyncStatus() {
        try {
            // Check the synchronization status
            const response = await this.request('GET', '/syncing/status');
            return response;
        } catch (error) {
            throw new Error(error?.message);
        }
    }

    /**
     * Fetches new data from Winsav.
     * @returns {Promise} A promise that resolves with the response data.
     * @throws {Error} If the request fails.
     */
    async syncNewData() {
        try {
            // Start synchronization for new data
            const response = await this.request('POST', '/syncing/start');
            return response;
        } catch (error) {
            throw new Error(error?.message);
        }
    }

    /**
     * Fetches existing data from Winsav.
     * @returns {Promise} A promise that resolves with the response data.
     * @throws {Error} If the request fails.
     */
    async syncExistingData() {
        try {
            // Start synchronization for existing data
            const response = await this.request('POST', '/syncing/start_existing');
            return response;
        } catch (error) {
            throw new Error(error?.message);
        }
    }
}

const syncService = new SyncService();
export default syncService;
